import { render } from "./ModalConfirmResendInvite.vue?vue&type=template&id=0bf4592e&scoped=true"
import script from "./ModalConfirmResendInvite.vue?vue&type=script&lang=js"
export * from "./ModalConfirmResendInvite.vue?vue&type=script&lang=js"

import "./ModalConfirmResendInvite.vue?vue&type=style&index=0&id=0bf4592e&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf4592e"]])

export default __exports__